import { Card, CardBody, CardHeader } from "../../../components/card/card";
function GeneralContent({ data }) {
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">General</CardHeader>
        <CardBody>
          <div className="list-group list-group-flush">
            <div className="list-group-item d-flex align-items-center">
              <div className="flex-1 text-break">
                <div className="text-theme">Title</div>
                <div className="text-inverse text-opacity-50">{data.training.trainingCode.title}</div>
              </div>
            </div>
          </div>
          <div className="list-group list-group-flush">
            <div className="list-group-item d-flex align-items-center">
              <div className="flex-1 text-break">
                <div className="text-theme">Code</div>
                <div className="text-inverse text-opacity-50">{data.training.trainingCode.code}</div>
              </div>
            </div>
          </div>
          <div className="list-group list-group-flush">
            <div className="list-group-item d-flex align-items-center">
              <div className="flex-1 text-break">
                <div className="text-theme">Category</div>
                <div className="text-inverse text-opacity-50">{data.category}</div>
              </div>
            </div>
          </div>
          <div className="list-group list-group-flush">
            <div className="list-group-item d-flex align-items-center">
              <div className="flex-1 text-break">
                <div className="text-theme">Remark</div>
                <div className="text-inverse text-opacity-50">{data.remark ?? "-"}</div>
              </div>
            </div>
          </div>
          <div className="list-group list-group-flush">
            <div className="list-group-item d-flex align-items-center">
              <div className="flex-1 text-break">
                <div className="text-theme">Training Goals :</div>
                {(data.trainingGoals || []).length > 0 ? (
                  data.trainingGoals.map((goal, index) => <div key={index} className="text-inverse text-opacity-50">{`- ${goal.text}`}</div>)
                ) : (
                  <div className="text-inverse text-opacity-50">No Data</div>
                )}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
}

export default GeneralContent;
